import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import useWindowDimensions from '../../utils/WIndowDimensions';
import Title from '../../Components/Title/Title';
import Popup from '../../Components/Popup/Popup';

import Image from '../../media/new_beginnings.svg';
import NewBeginningsSvg from '../../Components/Svg/NewBeginningsSvg';
import '../../css/Home.scss';

const Home: FC = (): JSX.Element => {
        const windowDimensions = useWindowDimensions();

    return (
        <main>
            <header>
                <div className="x1">
                    <div className="cloud"></div>
                </div>
                <div className="x2">
                    <div className="cloud"></div>
                </div>
                <div className="x3">
                    <div className="cloud"></div>
                </div>
                <Title />
            </header>
            <section className="title-container">
                <div className='image-center'>
                    <NewBeginningsSvg height={windowDimensions.height} width={windowDimensions.width}  />

                </div>

                <Popup placement="auto" strategy="absolute" modifiers={[]} />
                <div className="arrow bounce">
                    <FontAwesomeIcon icon={faArrowDown} className="fa fa-2x arrow-icon" />
                </div>
            </section>
            <section className="pb-12">
                <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center">
                        <h3 className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
                            How to Upload a New Photo
                        </h3>
                    </div>
                    <div className="mt-10">
                        <ul className="md:grid md:grid-cols-2 md:col-gap-8 md:row-gap-10">
                            <li>
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <div className="about-us-icons flex items-center justify-center h-12 w-12 rounded-md text-white">
                                            <svg
                                                className="h-6 w-6"
                                                stroke="currentColor"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="ml-4">
                                        <h5 className="text-lg leading-6 font-medium text-gray-900">Step 1</h5>
                                        <p className="mt-2 text-base leading-6 ">
                                            Read photo guidelines <b>below</b> and prepare to take a new photo.
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-10 md:mt-0">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <div className="about-us-icons flex items-center justify-center h-12 w-12 rounded-md text-white">
                                            <svg
                                                className="h-6 w-6"
                                                stroke="currentColor"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M13 10V3L4 14h7v7l9-11h-7z"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="ml-4">
                                        <h5 className="text-lg leading-6 font-medium text-gray-900">Step 2</h5>
                                        <p className="mt-2 text-base leading-6 ">
                                            Click on the Blue Camera icon above ^ to access your dashboard.
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-10 md:mt-0">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <div className="about-us-icons flex items-center justify-center h-12 w-12 rounded-md text-white">
                                            <svg
                                                className="h-6 w-6"
                                                stroke="currentColor"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="ml-4">
                                        <h5 className="text-lg leading-6 font-medium text-gray-900">Step 3</h5>
                                        <p className="mt-2 text-base leading-6 ">
                                            Select the the photo upload option of your choice.
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-10 md:mt-0">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <div className="about-us-icons flex items-center justify-center h-12 w-12 rounded-md text-white">
                                            <svg
                                                className="h-6 w-6"
                                                stroke="currentColor"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="ml-4">
                                        <h5 className="text-lg leading-6 font-medium text-gray-900">Step 4</h5>
                                        <p className="mt-2 text-base leading-6 ">
                                            Await approval email once CatCard admins have reviewed your new photo.
                                        </p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <section className="pb-12">
                <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center">
                        <h3 className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
                            Photo Submission Requirements
                        </h3>
                    </div>
                    <div className="mt-10">
                        <ul className="md:grid md:grid-cols-2 md:col-gap-8 md:row-gap-10">
                            <li>
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <div className="about-us-icons flex items-center justify-center h-12 w-12 rounded-md text-white">
                                            <FontAwesomeIcon icon={faCheckCircle as any} className="fa fa-2x h-6 w-6" />
                                        </div>
                                    </div>
                                    <div className="ml-4">
                                        <h5 className="text-lg leading-6 font-medium text-gray-900">
                                            Current color photo of yourself.
                                        </h5>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-10 md:mt-0">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <div className="about-us-icons flex items-center justify-center h-12 w-12 rounded-md text-white">
                                            <FontAwesomeIcon icon={faCheckCircle as any} className="fa fa-2x h-6 w-6" />
                                        </div>
                                    </div>
                                    <div className="ml-4">
                                        <h5 className="text-lg leading-6 font-medium text-gray-900">
                                            White or blue smooth background( no other people or objects in photo).
                                        </h5>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-10 md:mt-0">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <div className="about-us-icons flex items-center justify-center h-12 w-12 rounded-md text-white">
                                            <FontAwesomeIcon icon={faCheckCircle as any} className="fa fa-2x h-6 w-6" />
                                        </div>
                                    </div>
                                    <div className="ml-4">
                                        <h5 className="text-lg leading-6 font-medium text-gray-900">
                                            Sufficient lighting with no shadows.
                                        </h5>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-10 md:mt-0">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <div className="about-us-icons flex items-center justify-center h-12 w-12 rounded-md text-white">
                                            <FontAwesomeIcon icon={faCheckCircle as any} className="fa fa-2x h-6 w-6" />
                                        </div>
                                    </div>
                                    <div className="ml-4">
                                        <h5 className="text-lg leading-6 font-medium text-gray-900">
                                            Front view (full-face filling at least 80 percent of the frame).
                                        </h5>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-10 md:mt-0">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <div className="about-us-icons flex items-center justify-center h-12 w-12 rounded-md text-white">
                                            <FontAwesomeIcon icon={faCheckCircle as any} className="fa fa-2x h-6 w-6" />
                                        </div>
                                    </div>
                                    <div className="ml-4">
                                        <h5 className="text-lg leading-6 font-medium text-gray-900">
                                            Cropped from just above the top of head to the collarbone.
                                        </h5>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-10 md:mt-0">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <div className="about-us-icons flex items-center justify-center h-12 w-12 rounded-md text-white">
                                            <FontAwesomeIcon icon={faCheckCircle as any} className="fa fa-2x h-6 w-6" />
                                        </div>
                                    </div>
                                    <div className="ml-4">
                                        <h5 className="text-lg leading-6 font-medium text-gray-900">
                                            No hats or glasses and eyes open and visible.
                                        </h5>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <section className="flex flex-col justify-center items-center align-center">
                <h4 className="font-bold pb-4">Example of a Good Profile Photo</h4>
                <img src="http://catcard.ucmerced.edu/sites/catcard.ucmerced.edu/files/page/images/cat_card_freshman_photo.jpg" width="200" height="200" alt="example good id profile" />
            </section>
            <footer className="text-center pt-6">
                <p className="about-us-title text-base leading-6 font-semibold tracking-wide uppercase">
                    Created by CatCard Application Systems
                </p>
            </footer>
        </main>
    );
};

export default Home;
